import { PATH } from "~/constant/path";
import type { BreadCrumb } from "~/organisms/BreadCrumbs";

const constructUrl = (baseUrl: string, path: string) => {
  if (path.startsWith("http")) return path;
  return new URL(path, baseUrl).href;
};

/** ぱんくず専用のブログ表示名（ヘッダーメニュー名とは別） */
const INSIGHT_BREADCRUMB: BreadCrumb = {
  name: `Refcome Insightブログ`,
  to: PATH.INSIGHT.to,
};

/** Award系ページ用の年別ぱんくず項目を取得する */
export const getAwardYearCrumb = (year: string | number): BreadCrumb => {
  const eventsKey = `EVENTS_AWARD_${year}` as keyof typeof PATH;
  const awardKey = `AWARD_${year}` as keyof typeof PATH;

  return (
    PATH[eventsKey] ||
    PATH[awardKey] || {
      name: `${year}年受賞企業`,
      to: `/awards/${year}/`,
    }
  );
};

/** Award一覧ページ用のぱんくず */
export const buildAwardListBreadcrumbs = (year: string | number): BreadCrumb[] => [
  PATH.TOP,
  PATH.EVENTS,
  PATH.EVENTS_AWARD,
  getAwardYearCrumb(year),
];

/** Award記事ページ用のぱんくず */
export const buildAwardArticleBreadcrumbs = (year: string | number, title: string): BreadCrumb[] => [
  ...buildAwardListBreadcrumbs(year),
  { name: title },
];

/** ブログ記事ページ用のぱんくず */
export const buildInsightArticleBreadcrumbs = (title: string): BreadCrumb[] => [
  PATH.TOP,
  INSIGHT_BREADCRUMB,
  { name: title },
];

/** ブログ一覧ページ用のぱんくず */
export const buildInsightIndexBreadcrumbs = (categoryName?: string): BreadCrumb[] => {
  const items: BreadCrumb[] = [PATH.TOP, INSIGHT_BREADCRUMB];
  if (categoryName) {
    items.push({ name: categoryName });
  }
  return items;
};

/** Schema.org BreadcrumbList 用の構造化データを生成する */
export const buildBreadcrumbListSchema = (
  siteUrl: string,
  items: BreadCrumb[],
  canonicalUrl?: string
): Record<string, unknown> | null => {
  if (!items.length) return null;

  const itemListElement = items.map((item, index) => {
    const isLast = index === items.length - 1;
    const itemUrl = item.to
      ? constructUrl(siteUrl, item.to)
      : isLast && canonicalUrl
      ? canonicalUrl
      : undefined;

    return {
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      ...(itemUrl ? { item: itemUrl } : {}),
    };
  });

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement,
  };
};
